export const RETRY_ACTION = 'error/retry_action';
export const retryAction = () => ({
  type: RETRY_ACTION
});
